import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import { getGroupListData } from './mockData'
import type { THrid } from '~/types/models'
import type { IGroup } from '~/types/group/models'

interface GetGroupsResponse {
  data: IGroup[]
}

async function getGroups(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  console.log(`Returning groups`)
  const responseBody: GetGroupsResponse = { data: await getGroupListData() }
  return res(ctx.status(200), ctx.json(responseBody))
}

// post

const postGroup = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getGroupListData)
}

const patchGroup = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getGroupListData)
}

const deleteGroup = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getGroupListData)
}

export const handlers = [
  {
    method: 'get',
    path: '/api/groups',
    handler: getGroups,
  },
  {
    method: 'post',
    path: '/api/groups',
    handler: postGroup,
  },
  {
    method: 'patch',
    path: '/api/groups/:id',
    handler: patchGroup,
  },
  {
    method: 'delete',
    path: '/api/groups/:id',
    handler: deleteGroup,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
